/* @flow */

import React from 'react';
import { Message } from 'semantic-ui-react';

type Props = {
  warnings: Array<string>,
};

const PageWarnings = ({ warnings }: Props) => {
  if (warnings && warnings.length) {
    return (
      <Message
        header="Avertissements"
        icon="warning circle"
        warning
        list={warnings}
      />
    );
  }

  return null;
};

export default PageWarnings;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Page/Edit/components/PageWarnings.js